import {
  AllVehicleIssueResponseModel,
  CommonResponseModel,
  departmentIdReq,
  driverIdReq,
} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";

export class VehicleIssueService extends CommonAxiosService {
  URL = "/vehicleissue";

  async createVehicleIssue(payload: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/createVehicleIssue", payload);
  }

  async updateVehicleIssue(dto: any): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/updateVehicleIssue", dto);
  }

  async getEmployee(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getEmployee");
  }

  async getVehicle(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getVehicle");
  }

  async getdata(): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getEmployee");
  }

  async getAllVehicleissue(req?:driverIdReq): Promise<CommonResponseModel> {
    return this.axiosPostCall(this.URL + "/getAllVehicleissue" , req);
  }
  async vehicleIssuefileUpload(req: any): Promise<CommonResponseModel> {
    return await this.axiosPostCall(this.URL + "/vehicleIssuefileUpload", req);
  }
  async getVehicleIssueDashBoard(): Promise<CommonResponseModel> {
    return await this.axiosPostCall(this.URL + "/getVehicleIssueDashBoard");
  }
}
